import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class GlobalEventMangerService {

  private _showNavBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private _ghostLogin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public showNavBarEmitter: Observable<boolean> = this._showNavBar.asObservable();
  public ghostLoginEmitter: Observable<boolean> = this._ghostLogin.asObservable();

  constructor() { }
  
  showNavBar(ifShow: boolean) {
        this._showNavBar.next(ifShow);
  }
  
  ghostLogin(ifShow: boolean){
	this._ghostLogin.next(ifShow);
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/global-event-manger.service.ts